import React from 'react';
import './FormButton.scss';

interface FormButtonProps {
    buttonId: string;
    buttonType: 'submit' | 'button';
    type?: 'primary' | 'ghost';
    buttonText: string;
    classNames?: String;
    disabled: boolean;
    onClick?: () => void;
    dataTestId?: string;
}
const FormButton: React.FC<FormButtonProps> = ({
    buttonId,
    buttonType,
    buttonText,
    type = 'primary',
    classNames = '',
    onClick,
    disabled = false,
    dataTestId,
}) => (
    <button
        className={`form-button ${type} ${classNames}`}
        disabled={disabled}
        type={buttonType}
        id={buttonId}
        onClick={onClick}
        {...(dataTestId && { 'data-testid': dataTestId })}
    >
        {buttonText}
    </button>
);

export default FormButton;
